import WhyStructuredThinkingMattersSection from "./WhyStructuredThinkingMattersSection.js";
import WhatIsStructuredThinkingSection from "./WhatIsStructuredThinkingSection.js";
import WhyStructureBeatsMotivationSection from "./WhyStructureBeatsMotivationSection.js";
import EventVsInterpretationSection from "./EventVsInterpretationSection.js";
import EvidenceBasedThinkingSection from "./EvidenceBasedThinkingSection.js";
import RespondVsReactSection from "./RespondVsReactSection.js";
import ThinkingFrameworksSection from "./ThinkingFrameworksSection.js";
import ReflectionVsRuminationSection from "./ReflectionVsRuminationSection.js";
import TheEierFrameworkSection from "./TheEierFrameworkSection.js";
import FinalThoughtsSection from "./FinalThoughtsSection.js";

const SECTION_COMPONENTS = {
  "why-structured-thinking-matters": WhyStructuredThinkingMattersSection,
  "what-is-structured-thinking": WhatIsStructuredThinkingSection,
  "why-structure-beats-motivation": WhyStructureBeatsMotivationSection,
  "event-vs-interpretation": EventVsInterpretationSection,
  "evidence-based-thinking": EvidenceBasedThinkingSection,
  "respond-vs-react": RespondVsReactSection,
  "thinking-frameworks": ThinkingFrameworksSection,
  "reflection-vs-rumination": ReflectionVsRuminationSection,
  "the-eier-framework": TheEierFrameworkSection,
  "final-thoughts": FinalThoughtsSection,
};

export default SECTION_COMPONENTS;
